import { motion } from "framer-motion";
import * as Fa from "react-icons/fa";
import { SERVICES } from "../data/content";

const Services = () => (
    <section id="services" data-testid="services-section" className="relative py-20 sm:py-28 bg-slate-50/70 dark:bg-slate-950/60">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-center max-w-2xl mx-auto"
            >
                <div className="text-xs font-bold uppercase tracking-[0.25em] text-brand-600 dark:text-brand-300 mb-4">What We Do</div>
                <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold text-slate-900 dark:text-white">
                    Premium <span className="text-gradient-brand">Biomedical Services</span>
                </h2>
                <p className="mt-4 text-slate-600 dark:text-slate-300">End-to-end solutions: from procurement and installation to lifetime support.</p>
            </motion.div>

            <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5 sm:gap-6">
                {SERVICES.map((s, i) => {
                    const Icon = Fa[s.icon] || Fa.FaCog;
                    return (
                        <motion.div
                            key={s.title}
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.45, delay: (i % 4) * 0.06 }}
                            data-testid={`service-card-${i}`}
                            className="group relative p-6 rounded-3xl bg-white dark:bg-slate-900 border border-slate-200/70 dark:border-slate-800 hover:border-brand-300 dark:hover:border-brand-700 hover:-translate-y-1 hover:shadow-2xl hover:shadow-brand-500/10 transition-all overflow-hidden"
                        >
                            <div className="absolute -right-8 -top-8 w-24 h-24 rounded-full bg-brand-500/10 group-hover:scale-150 transition-transform duration-500" />
                            <div className="relative">
                                <div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-brand-700 to-brand-400 text-white flex items-center justify-center text-xl shadow-lg shadow-brand-700/30">
                                    <Icon />
                                </div>
                                <h3 className="mt-5 font-heading text-lg font-bold text-slate-900 dark:text-white">{s.title}</h3>
                                <p className="mt-2 text-sm text-slate-600 dark:text-slate-300 leading-relaxed">{s.desc}</p>
                            </div>
                        </motion.div>
                    );
                })}
            </div>
        </div>
    </section>
);

export default Services;
